import { Dispatch, SetStateAction, useEffect, useReducer, useState } from "react";
import { Plot } from "../../types";
import { LegendasWrapper } from "./LegendasWrapper";


export function SvgCross({x, y} : {x: number, y: number}) {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <line x1={0} x2={10} y1={0} y2={10} stroke="grey" strokeWidth={4} />
            <line x1={0} x2={10} y1={10} y2={0} stroke="grey" strokeWidth={4} />
        </g>
    )
}


export function SvgCheck({x, y, color} : {x: number, y: number, color: string}) {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <line x1={0} x2={3} y1={2} y2={9} stroke={color} strokeWidth={2} />
            <line x1={3} x2={10} y1={9} y2={2} stroke={color} strokeWidth={2} />
        </g>
    )
}


export function Legends({ plots, chartDimensions, mouseCoords ,filteredLabels, setFilteredLabels }: { plots: Plot[], mouseCoords: {x:number, y: number},chartDimensions: { width: number, height: number }, filteredLabels: string[], setFilteredLabels: Dispatch<SetStateAction<string[]>> }) {

    const yPos = 100;
    const xPos = 200;
    const height = plots.length * 30;
    const width = 250;

    const offset = 30;

    const [hoveredLabel, setHoveredLabel] = useState<number | null>(null);
    const [boxSelected, setBoxSelected] = useState<boolean>(false); 
    const [boxSelectedAt, setBoxSelectedAt] = useState({x: 0, y: 0});

    const [legendasPosition, setLegendasPosition] = useReducer((state: any, action: any) => {
        return { ...state, ...action }
    }, { x: xPos, y: yPos })


    useEffect(()=> {
        if(boxSelected) {
            setLegendasPosition({ x: mouseCoords.x - boxSelectedAt.x , y: mouseCoords.y - boxSelectedAt.y });
        }
    },[mouseCoords])

    const filterData = (label: string) => {
        setFilteredLabels((labels: string[]) => {
            if (labels.includes(label)) {
                return labels.filter((l: string) => l !== label)
            }
            return [...labels, label]
        })
    }

    const isDeselected = (label: string): boolean => {
        return filteredLabels.includes(label);
    }

    const labelHovered = (idx: number): boolean => idx === hoveredLabel;

    return (
        <LegendasWrapper boxSelected={boxSelected} setBoxSelectedAt={setBoxSelectedAt} setBoxSelected={setBoxSelected} position={legendasPosition} dimensions={{width: width, height: height}}>
            {plots.filter(p => !!p).map((p: Plot, idx: number) => {
                if(!p) return null;
                const rectXPosition = 10;
                const yRectPosition = 5 + idx * offset;
                const rectWidth = 16; 
                return (
                    <g key={idx} onClick={() => filterData(p.label)} onMouseEnter={()=> setHoveredLabel(idx)} onMouseLeave={()=> setHoveredLabel(null)} cursor={'pointer'}>
                        <rect x={rectXPosition} y={yRectPosition} width={rectWidth} height={rectWidth} stroke={labelHovered(idx) ? p.color: ''} strokeWidth={2} fill={ isDeselected(p.label) ? 'grey' : labelHovered(idx)? 'white': p.color} rx={5} />
                        {labelHovered(idx) && !isDeselected(p.label) ? <SvgCross x={rectXPosition + 3} y={yRectPosition + 3}/> : null}
                        {labelHovered(idx) && isDeselected(p.label) ? <SvgCheck x={rectXPosition + 3} y={yRectPosition + 3} color={p.color}/> : null}
                        
                        <text x={40} y={18 + idx * offset} textDecoration={`${isDeselected(p.label) ? 'line-through' : ''}`}>{p.label}</text>
                    </g>
                )
            })}
        </LegendasWrapper>
    )

}